
import { defineComponent, PropType } from 'vue'
import type { TActiveModalType } from '@entities/loyalty/model/types'

export default defineComponent({
  props: {
    activeModal: {
      type: String as PropType<TActiveModalType>,
      required: true,
      default: ''
    }
  },
  emits: [
    'closeActiveModalBonus',
    'changeActiveModalBonus',
    'setDiscount',
    'callYandexMetricGoal'
  ],
  methods: {
    callYandexMetricGoal (name: string) {
      this.$emit('callYandexMetricGoal', name)
    },
    closeActiveModalBonus (val: boolean) {
      this.$emit('closeActiveModalBonus', val)
    },

    // Меняем модалку
    changeActiveModalBonus (val: TActiveModalType) {
      this.$emit('changeActiveModalBonus', val)
    },

    setDiscount () {
      this.$emit('setDiscount')
    }
  }
})
